import {InputLabel} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import React, {useEffect, useState} from 'react';
import {withRouter} from 'react-router-dom';
import TipoPerfil from '../../../constants/tipoPerfil';
import Formatos from '../../../helpers/formatos';
import CabecalhoEdicao from '../usuarioForm/cabecalhoEdicao';
import useStyles from './styles';
import UploadFile from '../../shared/uploadFile'
import {download} from '../../../services/termo-posse/TermoPosseService';

const UsuarioView = (props) => {
  const {form} = props;
  const classes = useStyles();
  const [perfis, setPerfis] = useState([]);

  const handleDownload = (nomeTermoPosse, idTermoPosse) => async () => {
    try {
      const response = await download(idTermoPosse);
      const url = URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      document.body.appendChild(a);
      a.download = `${nomeTermoPosse}`;
      a.click();
    } catch (e) {
      // enqueueSnackbar('Ocorreu um erro ao realizar o download do arquivo', { variant: 'error' })
    }
  }

  useEffect(() => {
    setPerfis(form.perfis ? form.perfis : []);
  }, [form.perfis])

  function conselheiro (form) {
    return (
      <>
        <Grid item xs={12} sm={6}>
          <InputLabel className={classes.label}>Titularidade</InputLabel>
          <p className={classes.conteudo}>{form.conselheiroPerfil.descricaoTitularidade}</p>
        </Grid>

        <Grid item xs={12} sm={6}>
          <InputLabel className={classes.label}>Entidade</InputLabel>
          <p className={classes.conteudo}>{form.descricaoEntidade}</p>
        </Grid>

        <Grid item xs={12} sm={6}>
          <InputLabel className={classes.label}>Função na Entidade</InputLabel>
          <p className={classes.conteudo}>{form.ocupacao}</p>
        </Grid>

        <Grid item xs={12} sm={6}>
          <InputLabel className={classes.label}>Conselho</InputLabel>
          <p className={classes.conteudo}>{form.conselheiroPerfil.descricaoConselho}</p>
        </Grid>

        <Grid item xs={12} sm={6}>
          <InputLabel className={classes.label}>Comissão/comitê</InputLabel>
          <p className={classes.conteudo}>{form.conselheiroPerfil.descricaoComissaoComite}</p>
        </Grid>

        <Grid item xs={12} sm={6}>
          <InputLabel className={classes.label}>Interlocutor(a)</InputLabel>
          <p className={classes.conteudo}>{form.conselheiroPerfil.nomeInterlocutor}</p>
        </Grid>

        <Grid item xs={12} sm={6}>
          <InputLabel className={classes.label}>Função na Entidade</InputLabel>
          <p className={classes.conteudo}>{form.conselheiroPerfil.funcaoNaEntidadeInterlocutor}</p>
        </Grid>

        <Grid item xs={12} sm={6}>
          <InputLabel className={classes.label}>Telefone do(a) interlocutor(a)</InputLabel>
          <p className={classes.conteudo}>{Formatos.telefone(form.conselheiroPerfil.telefoneInterlocutor)}</p>
        </Grid>

        <Grid item xs={12} sm={6}>
          <InputLabel className={classes.label}>Email do(a) interlocutor(a)</InputLabel>
          <p className={classes.conteudo}>{form.conselheiroPerfil.emailInterlocutor}</p>
        </Grid>

        <Grid item xs={12}>
          <UploadFile titulo="Termo de Posse"
                      handleDownload={handleDownload(form.conselheiroPerfil.nomeTermoPosse, form.conselheiroPerfil.idTermoPosse)}
                      termoPosse={{
                        name: form.conselheiroPerfil.nomeTermoPosse,
                        uploadDate: form.conselheiroPerfil.dataInclusaoTermoPosse,
                        type: form.conselheiroPerfil.formatoTermoPosse,
                        size: form.conselheiroPerfil.tamanhoTermoPosse
                      }}/>
        </Grid>

        <Grid item xs={12}>
          <InputLabel className={classes.label}>Período de contribução</InputLabel>
          <p className={classes.conteudo}>{form.conselheiroPerfil.inicioDoMandato} - {form.conselheiroPerfil.fimDoMandato}</p>
        </Grid>
      </>
    )
  }

  function interlocutor (form) {
    return (
    <>
      <Grid item xs={12} sm={6}>
        <InputLabel className={classes.label}>Entidade</InputLabel>
        <p className={classes.conteudo}>{form.descricaoEntidade}</p>
      </Grid>

      <Grid item xs={12} sm={6}>
        <InputLabel className={classes.label}>Função na Entidade</InputLabel>
        <p className={classes.conteudo}>{form.ocupacao}</p>
      </Grid>

      <Grid item xs={12} sm={6}>
        <InputLabel className={classes.label}>Titularidade do Conselheiro</InputLabel>
        <p className={classes.conteudo}>{form.interlocutorPerfil.descricaoTitularidadeConselheiro}</p>
      </Grid>

      <Grid item xs={12} sm={6}>
        <InputLabel className={classes.label}>Nome do Conselheiro</InputLabel>
        <p className={classes.conteudo}>{form.interlocutorPerfil.nomeConselheiro}</p>
      </Grid>

      <Grid item xs={12} sm={6}>
        <InputLabel className={classes.label}>Conselho/comissão/comitês</InputLabel>
        <p className={classes.conteudo}>{form.interlocutorPerfil.descricaoConselho}</p>
      </Grid>

    </>
  )}

  function equipeTecnica(form) {
    return (
    <>
      <Grid item xs={12} sm={6}>
        <InputLabel className={classes.label}>Ocupação</InputLabel>
        <p className={classes.conteudo}>{form.ocupacao}</p>
      </Grid>

    </>
  )}

  return (
    <div className={classes.formularioCorpo}>
      <div style={{margin: '48px 56px'}}>
        <CabecalhoEdicao form={form} showSaveButton={false} tipoPerfil={form.idTipoPerfil} userId={form.id}/>
        <Grid container spacing={2}>

          <Grid item xs={12} sm={6}>
            <InputLabel className={classes.label}>E-mail Institucional</InputLabel>
            <p className={classes.conteudo}>{form.emailInstitucional}</p>
          </Grid>

          <Grid item xs={12} sm={6}>
            <InputLabel className={classes.label}>LinkedIn</InputLabel>
            <p className={classes.conteudo}>{form.linkedIn}</p>
          </Grid>

          <Grid item xs={12} sm={6}>
            <InputLabel className={classes.label}>Telefone comercial</InputLabel>
            <p className={classes.conteudo}>{Formatos.telefone(form.telefone)}</p>
          </Grid>

          <Grid item xs={12} sm={6}>
            <InputLabel className={classes.label}>Celular whatsapp</InputLabel>
            <p className={classes.conteudo}>{Formatos.celular(form.celular)}</p>
          </Grid>

          <Grid item xs={12}>
            <InputLabel className={classes.label}>Endereço para correspondência</InputLabel>
            <p className={classes.conteudo}>{form.endereco}</p>
          </Grid>

          <Grid item xs={12} sm={6}>
            <InputLabel className={classes.label}>CEP</InputLabel>
            <p className={classes.conteudo}>{Formatos.cep(form.cep)}</p>
          </Grid>


          {perfis.map((item, key) => {

            if (item.ativo) {

              return (

            <Grid container spacing={2} className={classes.retangulo}>
              <Grid container spacing={2} style={{padding: '16px'}}>

                <Grid item xs={12} sm={6}>
                  <InputLabel className={classes.label}>Tipo de Perfil</InputLabel>
                  <p className={classes.conteudo}>
                    {item.tipoPerfil === TipoPerfil.EQUIPE_TECNICA.id ? TipoPerfil.EQUIPE_TECNICA.descricao : ''}
                    {item.tipoPerfil === TipoPerfil.CONSELHEIRO.id ? TipoPerfil.CONSELHEIRO.descricao : ''}
                    {item.tipoPerfil === TipoPerfil.INTERLOCUTOR.id ? TipoPerfil.INTERLOCUTOR.descricao : ''}
                  </p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <InputLabel className={classes.label}>Atuação</InputLabel>
                  <p className={classes.conteudo}>{item.descricaoAtuacao}</p>
                </Grid>

                {item.tipoPerfil === TipoPerfil.CONSELHEIRO.id ? conselheiro(item) : null}
                {item.tipoPerfil === TipoPerfil.EQUIPE_TECNICA.id ? equipeTecnica(item) : null}
                {item.tipoPerfil === TipoPerfil.INTERLOCUTOR.id ? interlocutor(item) : null}

              </Grid>
            </Grid>

              )

            }

            return (

              <>

              </>

            );

          })}

        </Grid>
      </div>
    </div>
  );
};

export default withRouter(UsuarioView);
